export default __webpack_public_path__ + "static/media/loading_icon_bold.22996235.svg";